{
  "(optional)": "(необов’язково)",
  "(required)": "(обов’язково)"
}